/**
 * @generated SignedSource<<1f39e420f3cb36a0681004a4d0083dfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type CategoryListSortMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type CategoryListSortMutation$data = {
  readonly updateCategoryPositions: boolean;
};
export type CategoryListSortMutation = {
  response: CategoryListSortMutation$data;
  variables: CategoryListSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updateCategoryPositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryListSortMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CategoryListSortMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9392c68b4beacf0f065ea3f30dbe6e5b",
    "id": null,
    "metadata": {},
    "name": "CategoryListSortMutation",
    "operationKind": "mutation",
    "text": "mutation CategoryListSortMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateCategoryPositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "2ae43ecbe540ed00e58d15b3059ec978";

export default node;
